export const ORDER_NUMBER_MAX = 20;
export const ORDER_NUMBER_PATTERN = /^[A-Za-z0-9]+$/;
export const ORDER_NUMBER_FORMAT_ERROR =
  "Order number can only contain letters and numbers.";
export const ORDER_NUMBER_DUPLICATE_ERROR =
  "Purchase Order Number already exists. Please enter a unique Purchase Order Number.";
export const NOTE_MAX = 200;

/** Line-item quantity — max 6 digits (999,999). */
export const PO_LINE_QTY_MIN = 1;
export const PO_LINE_QTY_MIN_ERROR = "Minimum 1 qty required.";
export const PO_LINE_QTY_MAX = 999999;
export const PO_LINE_QTY_MAX_DIGITS = 6;

/** Line-item unit cost — max 999,999.99 (6 digits + 2 decimals). */
export const PO_LINE_UNIT_COST_MAX = 999999.99;
/** Register-style cost entry: cents digits for {@link PO_LINE_UNIT_COST_MAX}. */
export const PO_LINE_UNIT_COST_REGISTER_DIGITS = 8;

export const CSV_MAX_ROWS = 5000;
export const CSV_MAX_BYTES = 10 * 1024 * 1024;

export const ORDER_DETAILS_FIELDS = [
  { key: "supplier", type: "supplier", label: "Supplier", col: 1 },
  { key: "orderingFor", type: "select", label: "Location", col: 1 },
  { key: "stockDueDate", type: "date", label: "Stock Due", optional: true, col: 1 },
  {
    key: "orderNumber",
    type: "text",
    label: "Order number",
    maxLength: 20,
    showCount: true,
    col: 1,
  },
  {
    key: "supplierInvoice",
    type: "text",
    label: "Supplier Invoice Number",
    optional: true,
    placeholder: "Enter a Supplier Invoice Number",
    col: 1,
  },
  {
    key: "note",
    type: "textarea",
    label: "Note",
    optional: true,
    placeholder: "Enter a note for this order",
    maxLength: 200,
    showCount: true,
    col: 1,
  },
  { key: "preview", type: "preview", label: "Preview", col: 1 },
];
